<template>
  <b-modal :active="isVisible" :can-cancel="true" @close="close">
    <div class="has-background-white-ter p-4">
      <h3 class="is-size-5 has-text-weight-semibold mb-4">{{ isEdit ? 'Редактировать фразу' : 'Добавить фразу перевода' }}</h3>
      <form @submit.prevent="submit">
        <b-field
          label="Ключ"
          :type="errors.key ? 'is-danger' : ''"
          :message="Array.isArray(errors.key) ? errors.key[0] : errors.key"
        >
          <b-input v-model="form.key" maxlength="500" />
        </b-field>
        <b-field
          label="Язык"
          :type="errors.lang_code ? 'is-danger' : ''"
          :message="Array.isArray(errors.lang_code) ? errors.lang_code[0] : errors.lang_code"
        >
          <b-select v-model="form.lang_code" placeholder="Выберите язык" expanded>
            <option value="ru">Русский</option>
            <option value="kk">Қазақша</option>
            <option value="en">English</option>
          </b-select>
        </b-field>
        <b-field
          label="Значение"
          :type="errors.value ? 'is-danger' : ''"
          :message="Array.isArray(errors.value) ? errors.value[0] : errors.value"
        >
          <b-input v-model="form.value" type="textarea" maxlength="500" />
        </b-field>
        <b-field
          label="Категория (необязательно)"
          :type="errors.category ? 'is-danger' : ''"
          :message="Array.isArray(errors.category) ? errors.category[0] : errors.category"
        >
          <b-input v-model="form.category" maxlength="100" />
        </b-field>
        <div class="is-flex is-justify-content-end mt-4">
          <b-button label="Отмена" class="mr-3" :disabled="loading" @click="close" />
          <b-button type="is-info" :label="isEdit ? 'Сохранить' : 'Добавить'" :loading="loading" native-type="submit" />
        </div>
      </form>
    </div>
  </b-modal>
</template>

<script>
const FORM_INITIAL = {
  key: '',
  lang_code: 'ru',
  value: '',
  category: '',
};

export default {
  name: "TranslationPhraseModal",
  props: {
    isVisible: Boolean,
    phrase: { type: Object, default: null },
  },
  data() {
    return {
      form: { ...FORM_INITIAL },
      errors: {},
      loading: false,
    };
  },
  computed: {
    isEdit() {
      return this.phrase && this.phrase.id != null;
    },
  },
  watch: {
    phrase: {
      handler(val) {
        if (val && val.id != null) {
          this.form = {
            key: val.key ?? '',
            lang_code: val.lang_code ?? 'ru',
            value: val.value ?? '',
            category: val.category ?? '',
          };
        } else {
          this.form = { ...FORM_INITIAL };
        }
      },
      immediate: true,
    },
  },
  methods: {
    async submit() {
      this.errors = {};
      this.loading = true;
      try {
        const payload = {
          key: this.form.key,
          lang_code: this.form.lang_code,
          value: this.form.value,
        };
        if (this.form.category) payload.category = this.form.category;
        if (this.isEdit) {
          await this.$axios.put(`admin/translation-phrases/${this.phrase.id}`, payload);
        } else {
          await this.$axios.post('admin/translation-phrases', payload);
        }
        this.$emit('saved');
        this.close();
      } catch (e) {
        const res = e?.error?.response?.data;
        this.errors = res?.errors ?? (res?.message ? { _: [res.message] } : { _: ['Ошибка сохранения'] });
      } finally {
        this.loading = false;
      }
    },
    close() {
      this.form = { ...FORM_INITIAL };
      this.errors = {};
      this.$emit('update:isVisible', false);
      this.$emit('close');
    },
  },
};
</script>

<style scoped>
</style>
